export interface Breakpoints {
  sm: number;
  md: number;
  lg: number;
  xl: number;
  "2xl": number;
}

export const breakpoints: Breakpoints = {
  sm: 360,
  md: 768,
  lg: 992,
  xl: 1366,
  "2xl": 1920,
};
